<template>
  <aside id="mobile-menu" class="mobile-menu">
    <div class="overlay" @click.prevent="closeMenu" />
    <div class="nav-content">
      <button class="close-menu btn" @click.prevent="closeMenu">
        CLOSE X
      </button>
      <nav class="nav__items">
        <a
          href="https://fundraising.fracturedatlas.org/8-ball-community-inc"
          class="nav__link btn-donate"
          target="_blank"
          rel="noopener"
        >DONATE</a>
        <router-link
          :to="{ path: '/shows' }"
          class="nav__link"
          @click.native="closeMenu"
        >
          SHOWS
        </router-link>
        <router-link
          to="/schedule"
          class="nav__link"
          @click.native="closeMenu"
        >
          SCHEDULE
        </router-link>
        <a
          href="https://www.mixcloud.com/8ballradio/uploads/?order=oldest"
          target="_blank"
          rel="noopener"
          class="nav__link"
        >ARCHIVE</a>
        <a href="https://8ballcommunity.club/" class="nav__link">8-BALL FAMILY</a>
        <router-link
          to="/showsubmission"
          class="nav__link"
          @click.native="closeMenu"
        >
          SHOW SUBMISSION
        </router-link>
        <a
          href="https://8ballmarket.com/"
          target="_blank"
          rel="noopener"
          class="nav__link"
        >SHOP</a>
      </nav>
      <div class="top__social">
        <a
          href="https://www.facebook.com/eightballradio/"
          target="_blank"
          rel="noopener"
        >
          <img
            class="social__icon"
            src="../../assets/header/facebook.svg"
            onerror="this.src='../../assets/header/facebook.png'"
            alt="Facebook Fan Page"
          >
        </a>
        <a
          href="https://www.instagram.com/8ballradio/"
          target="_blank"
          rel="noopener"
        >
          <img
            class="social__icon"
            src="../../assets/header/instagram.svg"
            onerror="this.src='../../assets/header/instagram.png'"
            alt="Instagram"
          >
        </a>
        <a
          href="https://www.mixcloud.com/8ballradio/"
          target="_blank"
          rel="noopener"
        >
          <img
            class="social__icon"
            src="../../assets/header/mixcloud.svg"
            onerror="this.src='../../assets/header/mixcloud.png'"
            alt="Mixcloud"
          >
        </a>
      </div>
    </div>
  </aside>
</template>
<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      isSideBarOpen: false
    };
  },
  methods: {
    closeMenu() {
      this.$emit("closeMenu");
      this.isSideBarOpen = false;
      document.querySelector("#mobile-menu").classList.remove("active");
      document.body.style.overflow = "unset";
    }
  }
};
</script>
